import { type PromoValue } from './getPromoForOverlay';

export const getPromoNudge = (promo: PromoValue) => {
  return `Spend $${promo?.threshold} on your plan to get ${promo?.label}`;
};
